exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-page-shell[data-v-3fb1a7fa]{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.product-page-shell>*[data-v-3fb1a7fa]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:0}", ""]);

// exports
